import { render, staticRenderFns } from "./MelhorPlano.vue?vue&type=template&id=63110bce&scoped=true&"
import script from "./MelhorPlano.vue?vue&type=script&lang=js&"
export * from "./MelhorPlano.vue?vue&type=script&lang=js&"
import style0 from "./MelhorPlano.vue?vue&type=style&index=0&id=63110bce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63110bce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Trabalho\\Lupa Soluções em TI\\Clientes\\Leonardo Raton\\Site\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63110bce')) {
      api.createRecord('63110bce', component.options)
    } else {
      api.reload('63110bce', component.options)
    }
    module.hot.accept("./MelhorPlano.vue?vue&type=template&id=63110bce&scoped=true&", function () {
      api.rerender('63110bce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/SelecaoAssinatura/components/MelhorPlano.vue"
export default component.exports